const DataChannel1 =
    [{
        "name": { "type": "string" },
        "status": [
            {
                "type": "select",
                "options": ["enable",
                    "disabled"]
            },
        ],
        "slideBy": { "type": "number" },
        "windowLength": { "type": "number" },
        "indexes": [
            {
                "type": "select",
                "options": ["aswi",
                    "dqi"]
            },
        ],
        "aspects": [
            {
                "category": "frequency",
                "status": { "type": "boolean"},
                "fields": [{
                    "label": "expectedValue",
                    "type": "number",
                }, {
                    "label": "weightage",
                    "type": "number",
                },
                {
                    "label": "ttThreshold",
                    "type": "number",
                }]
            },
            {
                "category": "precision",
                "status": { "type": "boolean" },
                "fields": [{
                    "label": "expectedValue",
                    "type": "number",
                }, {
                    "label": "weightage",
                    "type": "number",
                },
                {
                    "label": "ttThreshold",
                    "type": "select",
                }]
            },
            {
                "category": "dataGap",
                "status": { "type": "boolean" },
                "fields": [{
                    "label": "expectedValue",
                    "type": "number",
                }, {
                    "label": "weightage",
                    "type": "number",
                },
                ]
            },
            {
                "category": "dataCount",
                "status": { "type": "boolean" },
                "fields": [{
                    "label": "expectedValue",
                    "type": "number",
                },
                {
                    "label": "ttThreshold",
                    "type": "select",
                }, {
                    "label": "weightage",
                    "type": "number",
                },
                ]
            },
            {
                "category": "latency",
                "status": { "type": "boolean" },
                "fields": [{
                    "label": "expectedValue",
                    "type": "number",
                },
                {
                    "label": "ttThreshold",
                    "type": "select",
                }, {
                    "label": "weightage",
                    "type": "number",
                },
                ]
            },
            {
                "category": "minValue",
                "status": { "type": "boolean" },
                "fields": [{
                    "label": "expectedValue",
                    "type": "number",
                },
                {
                    "label": "ttThreshold",
                    "type": "select",
                }, {
                    "label": "weightage",
                    "type": "number",
                },
                ]
            },
            {
                "category": "staleValue",
                "status": { "type": "boolean" },
                "fields": [
                    {
                        "label": "ttThreshold",
                        "type": "select",
                    }, {
                        "label": "weightage",
                        "type": "number",
                    },
                ]
            },
            {
                "category": "maxValue",
                "status": { "type": "boolean" },
                "fields": [{
                    "label": "expectedValue",
                    "type": "number",
                }, {
                    "label": "weightage",
                    "type": "number",
                },
                {
                    "label": "ttThreshold",
                    "type": "select",
                },
                // {
                //     "label": "complexRules",
                //     "complexRules": [
                //         {
                //             "label": "mnemonics",
                //             "type": "string",
                //         }, 
                //         {
                //             "label": "validateCondition",
                //             "type": "char",
                //         },
                //         {
                //             "label": "onSuccess",
                //             "type": "char",
                //         },
                //         {
                //             "label": "onFailure",
                //             "type": "char",
                //         },
                //     ]
                  
                // }
                ]
            },

        ]
    }]

const complexRules =
     [
        {
          "label": "mnemonics",
          "type": "string",
        },
        {
          "label": "validateCondition",
          "type": "char",
        },
        {
          "label": "onSuccess",
          "type": "char",
        },
        {
          "label": "onFailure",
          "type": "char",
        },
      ]

export {DataChannel1,complexRules};
    

    // function addComplexRulesToObject(obj) {
    //     if (obj.aspects) {
    //       obj.aspects.forEach(aspect => {
    //         aspect.fields.push({
    //           "label": "complexRules",
    //           "complexRules": [
    //             {
    //               "label": "mnemonics",
    //               "type": "string",
    //             },
    //             {
    //               "label": "validateCondition",
    //               "type": "char",
    //             },
    //             {
    //               "label": "onSuccess",
    //               "type": "char",
    //             },
    //             {
    //               "label": "onFailure",
    //               "type": "char",
    //             },
    //           ]
    //         });
    //       });
    //     }
    //   }
      
    //   DataChannel1.forEach(addComplexRulesToObject);
